import React from 'react';
import { IItemForGetShortInfo } from 'types';
import { TSelectedItem, TTypeOfModalWindow } from '../../../../../../../createVideoState/createVideoContext';
import StudioSelect from './components/StudioSelect';
import CreateDeveloperBtn from './components/CreateStudioBtn';
import style from './StudioField.module.scss';

interface IStudioField {
	setFetchedStudios: (value: IItemForGetShortInfo[]) => void;
	setIDStudio: (value: TSelectedItem) => void;
	refetchStudios: (value: boolean) => void;
	changeTypeOfModalWindow: (value: TTypeOfModalWindow) => void;
	needRefetchStudios: boolean;
}

const StudioField: React.FC<IStudioField> = ({
	setFetchedStudios,
	setIDStudio,
	refetchStudios,
	changeTypeOfModalWindow,
	needRefetchStudios,
}) => {
	return (
		<div className={style.container}>
			<StudioSelect
				setFetchedStudios={setFetchedStudios}
				setIDStudio={setIDStudio}
				refetchStudios={refetchStudios}
				needRefetchStudios={needRefetchStudios}
			/>
			<CreateDeveloperBtn changeTypeOfModalWindow={changeTypeOfModalWindow} />
		</div>
	);
};

export default React.memo(StudioField);
